import { loadMomentWithTzAndLocale } from './loadMomentWithTzAndLocale';

export function getMomentWithLocales(fullLocale: string, shortLocale: string) {
  if (!fullLocale) {
    return loadShortLocale();
  }

  return loadMomentWithTzAndLocale(fullLocale)
    .then((moment) => [moment, fullLocale])
    .catch(() => loadShortLocale());

  function loadShortLocale(): Promise<string | void> {
    return loadMomentWithTzAndLocale(shortLocale).then((moment) => [
      moment,
      shortLocale,
    ]);
  }
}
